const style = (theme) => {
  const output = {
    root: {
      display: 'block',
      position: 'relative',
      overflow: 'hidden',
    },
    animationNotReady: {
      opacity: 0,
      visibility: 'hidden',
    },
    firstText: {
      whiteSpace: 'nowrap',
    },
    secondText: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      whiteSpace: 'nowrap',
    },
    complete: {
      whiteSpace: 'normal',
    },
  }

  output[theme.mediaInverse.sm] = {
  }

  return output
}

export default style
